import logo from "./logo.svg";
import "./App.css";
import Home from "./Wifi/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Privacy from "./Wifi/Privacy";
import Homerut from "./Daorut/Homerut";
import Homerutonline from "./Daorut/Homerutonline";
import Homerutnhanh from "./Daorut/Homerutnhanh";
import Homerutuudai from "./Daorut/Homerutuudai";
import Homerutbaogia from "./Daorut/Homerutbaogia";
import Test from "./Daorut/Test";
import Clonehome from "./Daorut/Clonehome";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/home" element={<Home />} />
          <Route path="/wifi" element={<Home />} />
          <Route path="/test" element={<Test />} />
          <Route path="/*" element={<Homerut />} />
          <Route path="/p1" element={<Homerut />} />
          <Route path="/p2" element={<Clonehome />} />
          <Route path="/ruttienthetindungonline" element={<Homerutonline />} />
          <Route path="/rutnhanh" element={<Homerutnhanh />} />
          <Route path="/khuyenmai" element={<Homerutuudai />} />
          <Route path="/baogia" element={<Homerutbaogia />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
